import React, { useEffect } from "react"
import { useParams, useSearchParams } from "react-router-dom"
import { useAppCtx, appStore } from "lib/state"
import { queryTools } from "lib/utils"
import { TemplateWireframe } from "lib/designs/defleppard"
import { MainBuildArea } from "lib/units/template/build"

/* ===  
  BuilderWrapper is running in the admin area. When someone clicks on the Preview tab, BuilderWrapper can get the Mongo id of the template from the url..
  BuilderWrapper then looks up the Mongo id of the template and sends that to TemplateRenderWrapper along with the rp and subdomain.
  the TemplateRenderWrapper component MUST receive the entire template object, not just the id.
  === */


export default function BuilderWrapper({ children }:any){

  const { tmplid } = useParams()
  const [ searchParams, setSearchParams ] = useSearchParams();
  
  const { appState } = useAppCtx()
  const { store, AppStore }:any = appStore()

  const { update } = AppStore

  const { data:_Template } = queryTools.resource.parseQueryForApi("template.findById", { _id: tmplid })

  useEffect(() => {
    const elem = searchParams.get("elem")
    console.log(elem)
    if( elem !== store.element.refstr ){
      update("element", { refstr: elem })
    }
  },[searchParams.get("elem"), store.element.refstr])

  if( !_Template ) return <></>
  return (
    <div className="w-full h-screen flex flex-col pt-6">
      { searchParams.get("elem") === null ? (
        <TemplateWireframe />
      ) : (
        <MainBuildArea />
      )}
    </div>
  )
}

